import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  useMediaQuery,
  Chip,
  Pagination,
  Menu,
  MenuItem,
  InputBase,
  CircularProgress,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList"; // ✅ filter icon
import ExportDropdown from "../../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../../components/CustomText";
import AttendanceMap from "./MapTab.js";
import AttendanceCalendar from "./MapTab.js";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useTranslation } from "react-i18next";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import {
  convertUTCToLocalDateTime,
  formatCalendarDateForDisplay,
} from "../../../../components/dateTimeUtils";
import {
  getStatusBadgeBackgroundColor,
  getStatusBadgeForegroundColor,
} from "../../../../constants/statusPalette";
import { getAttendanceHistoryColorKey } from "../../Attendance/AttendanceHistory/attendanceHistoryStatusOptions";

import empty from "../../../../assets/empty.png";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import defaulttable from "../../../../assets/Attendance/defaulttable.svg";
import activetable from "../../../../assets/Attendance/activetable.svg";
import mapicon from "../../../../assets/Attendance/mapicon.svg";
import activemap from "../../../../assets/Attendance/activemap.svg";


const WorkerAttendance = ({workerId}) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [activeTab, setActiveTab] = useState("list");
  const [historyData, setHistoryData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
const [initialLoading, setInitialLoading] = useState(true); 
const [tableLoading, setTableLoading] = useState(false); 
  // ✅ filter drawer state
  const [filterOpen, setFilterOpen] = useState(false);
const [filters, setFilters] = useState({ status: "", startDate: "", endDate: "",  workers: [] });
const [isFilterApplied, setIsFilterApplied] = useState(false);

  const isMobile = useMediaQuery("(max-width:768px)");

  const normalizeStatusKey = (status) =>
    status
      ?.toLowerCase()
      .replace(/\s+/g, "")
      .replace(/-/g, "");

  const toTitleCase = (text = "") =>
    text.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

  const formatStatus = (status) => {
    const keyMap = {
      present: "attendanceStatus.present",
      earlyout: "attendanceStatus.early_clock_out",
      latearrival: "attendanceStatus.late_clock_in",
      lateout: "attendanceStatus.late_clock_out",
      lateandearlyout: "attendanceStatus.lateAndEarlyOut",
      leave: "attendanceStatus.leave",
      absent: "attendanceStatus.absent",
      halfleave: "attendanceStatus.halfLeave",
      hasissues: "attendanceStatus.unvalidatedPunches",
      halfday: "attendanceStatus.halfDay",
      overtime: "attendanceStatus.overtime",
    };

    const normalized = normalizeStatusKey(status);
    const translatedLabel = keyMap[normalized] ? t(keyMap[normalized]) : status;
    return translatedLabel ? toTitleCase(translatedLabel) : "--";
  };

  const formatLocalTime = (utcString) => {
    const localValue = convertUTCToLocalDateTime(utcString, {
      locale: "en-GB",
      formatOptions: { hour: "numeric", minute: "2-digit", hour12: true },
    });
    return localValue === "—" ? "-" : localValue;
  };

  const toDisplayTime = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const converted = formatLocalTime(value);
    if (converted !== "-") return converted;

    if (typeof value === "string" && value.trim()) return value.trim();
    return "-";
  };

  const getPunchTimesByAction = (row, actionType) => {
    const punches = Array.isArray(row?.punches) ? row.punches : [];
    return punches
      .filter((punch) => {
        const type = punch?.actionType || punch?.action_type || "";
        return type === actionType;
      })
      .map(
        (punch) =>
          punch?.occurredAt ||
          punch?.occurred_at ||
          punch?.formattedDateTime ||
          null
      )
      .filter(Boolean)
      .sort((a, b) => new Date(a) - new Date(b));
  };

  const getCompactTimes = (times = []) => {
    const safeTimes = (times || []).filter(Boolean);
    if (safeTimes.length <= 3) return safeTimes;
    return [safeTimes[0], "...", safeTimes[safeTimes.length - 1]];
  };

  const renderCompactTimeCell = (time, key) => {
    if (time === "...") {
      return (
        <Box key={key} component="div">
          ...
        </Box>
      );
    }

    return (
      <Box key={key} component="div">
        {toDisplayTime(time)}
      </Box>
    );
  };

  const renderPunchTimesCell = (row, actionType) => {
    const times = getPunchTimesByAction(row, actionType);
    if (times.length === 0) return "-";
    return getCompactTimes(times).map((time, index) =>
      renderCompactTimeCell(time, `${actionType}-${index}`)
    );
  };
useEffect(() => {
  const isFirstLoad = initialLoading;
  if (!isFirstLoad) setTableLoading(true);
  let url = `${BASE_URL}/company-admins/attendance/history?pageSize=5&page=${currentPage}&workerId=${workerId}`;
  if (filters.status) url += `&status=${filters.status}`;
  if (filters.startDate) url += `&dateFrom=${filters.startDate}`;
  if (filters.endDate) url += `&dateTo=${filters.endDate}`;
  
  // Add workers filter if present
  if (filters.workers.length > 0) {
    url += `&workers=${filters.workers.join(",")}`; // Pass worker IDs as comma-separated values
  }

  console.log("📡 Fetching attendance history with URL:", url);  // Log the final URL with filters

  fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${decryptedToken}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("✅ API response:", data);  // Log the data received from the API

      if (!data.error && data.data?.records) {
        const mapped = data.data.records.map((rec) => {
          const getActionType = (p) => p?.actionType || p?.action_type || "";
          const clockIns =
            rec.punches?.filter((p) => getActionType(p) === "CLOCK_IN") || [];
          const clockOuts =
            rec.punches?.filter((p) => getActionType(p) === "CLOCK_OUT") || [];
          const firstClockIn = clockIns[0];
          const lastClockOut = clockOuts[clockOuts.length - 1];
          const dateSource =
            firstClockIn?.occurredAt ||
            firstClockIn?.occurred_at ||
            lastClockOut?.occurredAt ||
            lastClockOut?.occurred_at ||
            rec.date;

          return {
            id: rec.worker.employeeId,
            fullName: rec.worker.fullName,
            date: formatCalendarDateForDisplay(dateSource),
            punches: rec.punches || [],
            location: rec.locationSummary || "-",
            details: `${t("attendanceHistory.issues")}: ${rec.attendance.issuesCount}`,
            status: rec.statusBadge?.text || "-",
            raw: rec,
          };
        });

        console.log("Mapped Data for Table:", mapped);  // Log the final data after mapping for the table

        setHistoryData(mapped);
        setTotalPages(data.data.pagination.totalPages || 1);
      } else {
        setHistoryData([]);
        setTotalPages(1);
      }
    })
    .catch((err) => {
      console.error("❌ Error fetching attendance history:", err);
      setHistoryData([]);
    })
    .finally(() => {
      if (isFirstLoad) {
        setInitialLoading(false);
      } else {
        setTableLoading(false);
      }
    });
}, [currentPage, decryptedToken, filters]); // Ensure `filters` is included as a dependency
// Make sure `filters` is included as a dependency



  const HeaderStyles = {
    color: "#44546F",
    fontSize: "15px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const TimeHeaderStyles = {
    ...HeaderStyles,
    minWidth: "90px",
    px: "10px",
  };

  const TimeCellStyles = {
    ...DataStyles,
    minWidth: "90px",
    px: "10px",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "unset",
    verticalAlign: "top",
  };

  const filteredData = historyData.filter(
    (row) =>
      row.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.details.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 2, border: "2px solid #091E4224", py: 2, m: 1 }}>
      {/* Header */}
      <Box
        sx={{
          pb: 2,
          px: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
    
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, pb: 1 }}>
      <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149" }}>
        {t("attendanceHistory.heading")}
      </CustomText>
      {tableLoading && <CircularProgress size={20} sx={{ ml: 1 }} />}
    </Box>

        {/* Search */}
        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            placeholder={t("attendanceHistory.searchPlaceholder")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              ml: 0.5,
              fontSize: 15,
              fontFamily: "Poppins, sans-serif",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* Tabs */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D9D9D9",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            {[
              { key: "list", defaultIcon: defaulttable, activeIcon: activetable },
              { key: "map", defaultIcon: mapicon, activeIcon: activemap },
              // { key: "calendar", defaultIcon: calender, activeIcon: activecalender },
            ].map((tab, index) => (
              <Box
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                sx={{
                  width: 50,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backgroundColor: activeTab === tab.key ? "#006EC2" : "#fff",
                  borderRight: index !== 2 ? "1px solid #D9D9D9" : "none",
                }}
              >
                <img
                  src={activeTab === tab.key ? tab.activeIcon : tab.defaultIcon}
                  alt={tab.key}
                  style={{ width: 20, height: 20 }}
                />
              </Box>
            ))}
          </Box>

        

        </Box>
      </Box>

      {/* Tabs content */}
      {activeTab === "map" && <AttendanceMap workerId={workerId} />}
      {/* {activeTab === "calendar" && <AttendanceCalendar />} */}
      {activeTab === "list" && (
        <>
        {initialLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300 }}>
              <CircularProgress />
            </Box>
          ) : filteredData.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: 5,
              }}
            >
              <img src={empty} alt="No Data" style={{ width: 200, marginBottom: 16 }} />
              <Typography sx={{ fontSize: "15px" }}>{t("attendanceSettings.noWorkers")}</Typography>
            </Box>
          ) : (
            <>
              <Box sx={{ overflowX: "auto", width: "100%" }}>
              <TableContainer component={Paper} sx={{ boxShadow: "none", px: 1 }}>
                <Table sx={{ minWidth: 1000 }} size="small">
                  <TableHead
                    sx={{
                      borderTop: "2px solid #091E4224",
                      borderBottom: "2px solid #091E4224",
                    }}
                  >
                    <TableRow>


                     <TableCell sx={HeaderStyles}>{t("attendanceHistory.tableHeaders.fullName")}</TableCell>
                      <TableCell sx={HeaderStyles}>{t("attendanceHistory.tableHeaders.date")}</TableCell>
                      <TableCell sx={TimeHeaderStyles}>{t("clock_in")}</TableCell>
                      <TableCell sx={TimeHeaderStyles}>{t("break_start")}</TableCell>
                      <TableCell sx={TimeHeaderStyles}>{t("break_end")}</TableCell>
                      <TableCell sx={TimeHeaderStyles}>{t("clock_out")}</TableCell>
                      <TableCell sx={HeaderStyles}>{t("attendanceHistory.tableHeaders.location")}</TableCell>
                      <TableCell sx={HeaderStyles}>{t("attendanceHistory.tableHeaders.details")}</TableCell>
                      <TableCell sx={HeaderStyles}>{t("attendanceHistory.tableHeaders.status")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData.map((row, index) => (
                      <TableRow key={index}>
                     
                       
                        <TableCell sx={DataStyles}>{row.fullName}</TableCell>
                        <TableCell sx={DataStyles}>{row.date}</TableCell>
                        <TableCell sx={TimeCellStyles}>
                          {renderPunchTimesCell(row, "CLOCK_IN")}
                        </TableCell>
                        <TableCell sx={TimeCellStyles}>
                          {renderPunchTimesCell(row, "BREAK_START")}
                        </TableCell>
                        <TableCell sx={TimeCellStyles}>
                          {renderPunchTimesCell(row, "BREAK_END")}
                        </TableCell>
                        <TableCell sx={TimeCellStyles}>
                          {renderPunchTimesCell(row, "CLOCK_OUT")}
                        </TableCell>
                        <TableCell sx={DataStyles}><TruncatedCell text={row.location} /></TableCell>
                        <TableCell sx={DataStyles}><TruncatedCell text={row.details} /></TableCell>
                        <TableCell sx={{ ...DataStyles, whiteSpace: "nowrap" }}>
                          <Chip
                            label={formatStatus(row.status)}
                            sx={{
                              backgroundColor: getStatusBadgeBackgroundColor(
                                getAttendanceHistoryColorKey(row.status)
                              ),
                              color: getStatusBadgeForegroundColor(
                                getAttendanceHistoryColorKey(row.status)
                              ),
                              fontSize: "13px",
                              fontWeight: 500,
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                              borderRadius: "4px",
                              whiteSpace: "nowrap",
                            }}
                          />
                        </TableCell>
                
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(_, value) => setCurrentPage(value)}
                  shape="rounded"
                  color="primary"
                  size="small"
                  disabled={loading}
                />
              </Box>
            </>
          )}
        </>
      )}

    
  


    </Box>
  );
};

export default WorkerAttendance;